// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"467":"38f1998b","496":"e5b7e134","711":"6010de33"}[chunkId] + ".chunk.js";
};